import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import OkCancelModal from './OkCancelModal';
import { messages } from './FilterSave';
export const FilterSaveModal = ({ isNameModalOpen, modalFilter, saveFilter, setModalFilter, setIsNameModalOpen, }) => {
    const { formatMessage } = useIntl();
    const closeModal = () => {
        setIsNameModalOpen(false);
        setModalFilter(undefined);
    };
    const handleNameInputKeyDownEvent = (e) => {
        if (e.keyCode === 13) {
            saveFilter();
        }
        else if (e.keyCode === 27) {
            closeModal();
        }
    };
    const onChange = (e) => {
        setModalFilter(Object.assign(Object.assign({}, modalFilter), { name: e.target.value }));
    };
    const nameInput = useMemo(() => { var _a; return (_a = modalFilter === null || modalFilter === void 0 ? void 0 : modalFilter.name) !== null && _a !== void 0 ? _a : ''; }, [modalFilter === null || modalFilter === void 0 ? void 0 : modalFilter.name]);
    if (isNameModalOpen) {
        return (_jsxs(OkCancelModal, Object.assign({ title: formatMessage(messages.SearchCriteriaNameInputTitle), show: true, onClose: closeModal, onSave: saveFilter, disableFullScreen: true }, { children: [_jsx("div", { children: formatMessage(messages.SearchCriteriaNameInputMessage) }), _jsx("div", { children: _jsx("input", { type: "text", value: nameInput, onChange: onChange, className: "form-control", maxLength: 50, autoFocus: true, onKeyDown: handleNameInputKeyDownEvent, placeholder: formatMessage(messages.SearchCriteriaNameInputPlaceholder) }) })] })));
    }
    return null;
};
